class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }
        
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


$("#closesidebar").click(function(e){
  e.preventDefault();
  $(".preworn-sidebar-cart-contents").hide();

});


$("#cart-icon-bubble").click(function(e){
  e.preventDefault();
  $(".preworn-sidebar-cart-contents").css('display', 'flex');

});

$(document).on('click', '.remove-item-sidebar', function(e){ 

    e.preventDefault();
    console.log(e.target.id);
    var vid = e.target.closest('.remove-item-sidebar').id;

    e.target.closest(".sidebar-cart-item").remove();
    var items = 
    {
      "id": vid,
      "quantity": 1
    };
    removeSideItem(vid);

  function removeToSideCartOk(product) 
  { 
     e.target.classList.remove("fa-remove");
     e.target.classList.add("fa-cart-arrow-down");

     
     jQuery.getJSON('/cart.js', function (cart, textStatus) 
     {
        //the cart info is in the callback. the item_count is available as part of the callback
        //below I set my cartcount div with the current cart item_count
        var carttext="(" +cart.item_count + ")";
        jQuery(".count-cart-sidebar").text(carttext);
        jQuery(".cart-count-bubble").text(carttext);

       if(cart.item_count == 0)
          {

            var emptycartitem  = document.createElement('div');
            emptycartitem.classList.add("cart-item-link"); 
            emptycartitem.innerHTML ='<div id="emptycartfiller" class="sidebar-cart-item"><p>Cart Is Empty</p></div>';
                var cartdiv = document.getElementsByClassName('preworn-flex-container')[0];
                cartdiv.appendChild(emptycartitem);
          }
       
      });

      console.log(product.items);
      iCartTotal = 0;
      var incoming = product.items
      var arrayCartItems = incoming;
      var arrayLength = arrayCartItems.length;
      for (var i = 0; i < arrayLength; i++) 
      {
        iCartTotal = iCartTotal + arrayCartItems[i].original_price;
      }
      

      var iCartTotalTemp  = iCartTotal/100;
      var cartLoyalty = document.getElementById('cartLoyaltyTotal');
      var loyaltyPrice = iCartTotalTemp * 0.25;
      loyaltyPrice = loyaltyPrice.toFixed(2);
      cartLoyalty.innerHTML = "LOYALTY: £" + loyaltyPrice + " OFF Your Next Order";

      var cartFreeShipping = document.getElementById('cartFreeShippingOff');
      var cartFreeShippingPrice = 20-iCartTotalTemp;

      if(cartFreeShippingPrice > 0)
      {
        cartFreeShippingPrice = cartFreeShippingPrice.toFixed(2);
        cartFreeShipping.style.background = "#ff8000";
        cartFreeShipping.innerHTML = "Get Free Shipping: Add £" + cartFreeShippingPrice;
      }
      else
      {
        cartFreeShipping.style.background = "Green";
        cartFreeShipping.innerHTML = "You Have Earnt FREE Shipping";
      }

  
      var cart5OffCount = document.getElementById('cart5OffCount');
      var cart5OffCountPrice = 25-iCartTotalTemp;
      if(cart5OffCountPrice > 0)
      {
        cart5OffCountPrice = cart5OffCountPrice.toFixed(2);
        cart5OffCount.style.background = "#ff8000";
        cart5OffCount.innerHTML = "Get £5 OFF: ADD £" + cart5OffCountPrice;
      }
      else
      {
        cart5OffCount.style.background = "Green";
        cart5OffCount.innerHTML = "You Have Got £5 OFF Your Order";
      }
      var cartSideBarPrice = document.getElementById('cartSideBarPrice');


      function formatMoney(number) {
        number = number.toFixed(2);
        const valueArray = number.split(".");
          var strNumber = '<span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem; position: relative; margin-right: 0px;color: #000;" class="poundSignSide">£</span><span style="font-weight: bold; font-size: 3rem; position: relative; margin-right: 1px;color: #000;" class="poundActualSide">';
          strNumber = strNumber.concat(valueArray[0]);
          strNumber = strNumber.concat('</span> <span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem;margin-left: -2px; position: relative; margin-right: 0px;color: #000; class="poundActualSide">');
          strNumber = strNumber.concat(valueArray[1]);
          strNumber = strNumber.concat("</span>");
          return strNumber;
        }

      var priceHTML = formatMoney(iCartTotalTemp);
      cartSideBarPrice.innerHTML = priceHTML;
      

   } 

  function removeSideItem(vid) 
  {
    items = {
      "id": vid,
      "quantity": 0
    }      
    $.ajax({
       type: 'POST', 
       url: '/cart/change.js',
       dataType: 'json', 
       data:  items, 
       success: removeToSideCartOk,
       error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    });
    }
  });


customElements.define('cart-notification', CartNotification);
